import * as React from 'react';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { __ } from 'react-i18n';
import { IconType, SvgIcon } from '../General/SvgIcon';

interface Props {
  title: string;
  desc: string;
}

export function CategoryHeader({ title, desc }: Props) {
  const [isShowingAll, setIsShowingAll] = React.useState(false);
  const descSize = 200;
  const shortCategoryDescr =
    desc && desc.length > descSize ? desc.substr(0, descSize) + '...' : null;

  const toggleShowingAll = () => {
    setIsShowingAll(!isShowingAll);
  };

  return (
    <>
      <DesktopWrapper>
        {desc && desc !== '' && (
          <Description dangerouslySetInnerHTML={{ __html: desc }} />
        )}
      </DesktopWrapper>
      <MobileWrapper>
        <Title>{title}</Title>
        {desc && desc !== '' && (
          <Description
            dangerouslySetInnerHTML={{
              __html:
                !isShowingAll && shortCategoryDescr ? shortCategoryDescr : desc,
            }}
          />
        )}
        {shortCategoryDescr && (
          <ShowMoreWrapper onClick={toggleShowingAll}>
            {isShowingAll ? __('Skryť') : __('Zobraziť popis')}
            <SvgIcon
              cursor={'pointer'}
              width={16}
              height={16}
              marginLeft={8}
              fill={'#07151C'}
              rotate={isShowingAll ? 180 : 0}
              alt="arrow-icon"
              icon={IconType.downArrow}
            />
          </ShowMoreWrapper>
        )}
      </MobileWrapper>
    </>
  );
}

const DesktopWrapper = styled(FlexCol)`
  display: block;

  ${({ theme }) => theme.mediab.l925`
    display: none;
  `}
`;

const MobileWrapper = styled(FlexCol)`
  display: none;

  ${({ theme }) => theme.mediab.l925`
    display: block;
  `}
`;

const Title = styled.h1`
  font-weight: bold;
  font-size: ${rem(30)};
  font-family: ${({ theme }) => theme.font.secondary};
  line-height: ${rem(38)};
  margin-bottom: ${rem(24)};
  color: ${({ theme }) => theme.colors.black};

  ${({ theme }) => theme.mediab.l925`
    font-weight: 500;
    font-size: ${rem(24)};
    line-height: ${rem(31)};
    text-transform: uppercase;
    margin-bottom: ${rem(0)};
  `}
`;

const Description = styled.div`
  font-weight: 300;
  line-height: ${rem(22)};
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.black};
  margin-top: 0;
  margin-bottom: ${rem(24)};
  word-break: break-all;

  ${({ theme }) => theme.mediab.l925`
    margin-top: ${rem(24)};
    margin-bottom: 0;
  `}

  & > p {
    margin: 0;
  }
`;

const ShowMoreWrapper = styled(FlexRowCenterVertical)`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
  width: fit-content;
  cursor: pointer;
  margin-top: ${rem(8)};
`;
